export const ParticipantTypes = {
  naturalPerson: 'naturalPerson',
  legalEntity: 'legalEntity',
};



// WEBPACK FOOTER //
// ./src/models/auth/ParticipantTypes.js